'use client';

import { toast } from '@/lib/ui/toast';
import { useEffect } from 'react';

export type WorkspaceLoadErrorCopy = {
  loadFailed: string;
  retry?: string;
};

export function useWorkspaceLoadErrorToast({
  errorCopy,
  hasError,
  onRetry,
}: {
  errorCopy: WorkspaceLoadErrorCopy;
  hasError: boolean;
  onRetry: () => void;
}) {
  useEffect(() => {
    if (!hasError) return;

    toast.error(errorCopy.loadFailed, {
      action: errorCopy.retry
        ? { label: errorCopy.retry, onClick: onRetry }
        : undefined,
    });
  }, [errorCopy.loadFailed, errorCopy.retry, hasError, onRetry]);
}
